const bdayLock = ref(false);
const isReferralInputActive = ref(false);
const hasSeenCompleteRegModal = ref(false);

export default () => {
  const lockDateOfBirth = () => {
    bdayLock.value = true;
  };

  const unlockDateOfBirth = () => {
    bdayLock.value = false;
  };

  const toggleReferralInputActive = () => {
    const { $trackEvent } = useNuxtApp();
    isReferralInputActive.value = !isReferralInputActive.value;
    $trackEvent('RegistrationEvent', 'REG_TOGGLE_REFERRAL_INPUT');
  };

  return {
    bdayLock: readonly(bdayLock),
    isReferralInputActive: readonly(isReferralInputActive),
    lockDateOfBirth,
    unlockDateOfBirth,
    toggleReferralInputActive,
    hasSeenCompleteRegModal,
  };
};
